import Anchor from "./Anchor.svelte";
import Key from "./Key.svelte";
import Mermaid from "./Mermaid.svelte";
export default { mermaid: Mermaid, anchor: Anchor, key: Key };
